import { useEffect, useState } from 'react';
import api from '../api';
import { QUALITY_SERVICE_API_URL } from '../config';

const useHistoricalData = (isOpen, content, startDate, endDate, testId, selectedEnvironment, isCsqXp = false) => {
  const [historicalData, setHistoricalData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchHistoricalData = async () => {
      if (isOpen) {
        setLoading(true);
        try {
          const response = await api.post(`${QUALITY_SERVICE_API_URL}/hub/test-history`, {
            testId,
            startDate,
            endDate,
            env: selectedEnvironment.toLowerCase(),
            isCsqXp,
          });
          setHistoricalData(response.data);
        } catch (err) {
          setError(err);
        } finally {
          setLoading(false);
        }
      }
    };

    fetchHistoricalData();
  }, [isOpen, startDate, endDate, testId, selectedEnvironment, isCsqXp]);

  return { historicalData, loading, error };
};

export default useHistoricalData; 